import { useEffect, useState } from 'react'
import { SelectCustom } from '../../../../../../ui/molecules/select'
import '../../../../styles.scss'
import { SingleCheckbox } from '../../../../../../ui/molecules/SingleCheckbox'
import { ProtocolSearch } from '../../../../../../ui/molecules/ProtocolSearch'
import Input from '../../../../../../ui/molecules/input'
import { VariationTable } from '../../components/variationsTable'
import TextArea from '../../../../../../ui/molecules/textArea'
import { useAppDispatch, useAppSelector } from '../../../../../../lib/redux/hooks'
import { setNotificationStatusUpdateCertidiedOtherCauses, setNotificationStatusUpdateCertifiedNonCompliantNotification, setNotificationStatusUpdateCertifiedNote, setNotificationStatusUpdateCertifiedSubsequentNotificationIssue, setNotificationStatusUpdateDocumentIntegrationRequestId, setNotificationStatusUpdateExpirationType, setNotificationStatusUpdateNote, setNotificationStatusUpdateNotEmittedCertifiedId, setNotificationStatusUpdateNotificationProtocolId, setNotificationStatusUpdateOfficerId, setNotificationStatusUpdateVariationCauses } from '../../slice'
import { GetAllRID, resetGetAllRIDStatus } from '../../../../../gestioneClienti/RID/slice'
import { formatterDate, NotificationExpirationTypeOptions, OptionType } from '../../../../../../utils'

export function NotifyStatusEditForms() {
    const dispatch = useAppDispatch()
    const notificationStatusState = useAppSelector(state => state.notificationStatus)
    const ridState = useAppSelector(state => state.rid)
    const userState = useAppSelector(state => state.users)
    const sessionState = useAppSelector(state => state.session)
    const [RIDOptions, setRIDOptions] = useState<OptionType[]>([])
    const [nextNotify, setNextNotify] = useState<boolean>(false)
    const [nonCompliantNotify, setNonCompliantNotify] = useState<boolean>(false)
    const [otherMotivationsNotify, setOtherMotivationsNotify] = useState<boolean>(false)

    useEffect(() => {
        if (notificationStatusState.notificationStatusUpdateRequest.certifiedSubsequentNotificationIssue !== null)
            setNextNotify(notificationStatusState.notificationStatusUpdateRequest?.certifiedSubsequentNotificationIssue || false)

        if (notificationStatusState.notificationStatusUpdateRequest.certifiedNonCompliantNotification !== null)
            setNonCompliantNotify(notificationStatusState.notificationStatusUpdateRequest?.certifiedNonCompliantNotification || false)

        if (notificationStatusState.notificationStatusUpdateRequest.certifiedOtherCauses !== null)
            setOtherMotivationsNotify(notificationStatusState.notificationStatusUpdateRequest?.certifiedOtherCauses || false)
        
        dispatch(GetAllRID({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }))

        dispatch(setNotificationStatusUpdateOfficerId(userState.findMeResponse.id))
    }, [])

    useEffect(() => {
        if(ridState.getAllRidStatus === 'successfully' &&
            ridState.getAllRidResponse !== undefined
        ) {
            dispatch(resetGetAllRIDStatus())

            const data = ridState.getAllRidResponse.data.map(rid => {
                return {
                    value: rid.id,
                    label: `${rid.departureProtocolInfo} del ${formatterDate(rid.date)}`
                } as OptionType
            })
            setRIDOptions(data)
        }
    }, [ridState.getAllRidStatus])


    return (
        <div className="notify-container">
            <div className='notify-header'>
                <div className='text-left'>
                    <span className='notify-title-bold' style={{ color: '#fff' }}>Notifica </span>
                    <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                    <span className='notify-title-bold' style={{ color: '#d9e6e8' }}> Modifica della valutazione</span>
                </div>
            </div>

            <div style={{ padding: '24px' }}>
                <div className='pb-5'>
                    <div className='text-left mb-5'>
                        <div className='notify-subtitle'>
                            Monitoraggio Iter Notifica - Tempistiche emissione CDX M0005 - Documento Giustificativo
                        </div>
                    </div>

                    <div className='mb-5'>
                        <div className='text-left notify-text-bold'>
                            Tipologia di Scadenza
                        </div>
                        <SelectCustom
                            placeholder='Seleziona tipologia...'
                            value={notificationStatusState.notificationStatusUpdateRequest.expirationType}
                            options={NotificationExpirationTypeOptions}
                            onChange={(value) => dispatch(setNotificationStatusUpdateExpirationType(value))}
                        />
                    </div>
                </div>

                <div className='text-left pb-5 mb-5' style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #74A4A9' }}>
                    <div className='notify-text-bold'>
                        Data di rilascio
                    </div>
                    <span className='notify-text-content pb-[2px]'>
                        15/04/2025
                    </span>
                </div>

                <div className='mb-5 pb-5' style={{ borderBottom: '1px solid #74A4A9' }}>
                    <div className='text-left notify-subtitle'>
                        Protocollo Entrata della Notifica
                    </div>
                    <ProtocolSearch
                        type="entry"
                        defaultValue={notificationStatusState.notificationStatusUpdateRequest.notificationProtocolId}
                        onSelect={(value) => dispatch(setNotificationStatusUpdateNotificationProtocolId(value))}
                    />
                </div>

                <div className='mb-5 pb-5' style={{ borderBottom: '1px solid #74A4A9' }}>
                    <div className='text-left notify-subtitle mb-3'>
                        Gestione Certificato
                    </div>

                    <div className='mb-3'>
                        <SingleCheckbox
                            label='Non emettere certificato - emessa Notifica successiva'
                            checked={nextNotify}
                            setChecked={(value) => {
                                dispatch(setNotificationStatusUpdateCertifiedSubsequentNotificationIssue(value))
                                setNextNotify(value)
                            }}
                        />
                    </div>

                    <div className='mb-3'>
                        <SingleCheckbox
                            label='Non emettere certificato - Notifica non conforme'
                            checked={nonCompliantNotify}
                            setChecked={(value) => {
                                dispatch(setNotificationStatusUpdateCertifiedNonCompliantNotification(value))
                                setNonCompliantNotify(value)
                            }}
                        />
                    </div>

                    <div className='mb-5'>
                        <SingleCheckbox
                            label='Non emettere certificato - Altre cause'
                            checked={otherMotivationsNotify}
                            setChecked={(value) => {
                                dispatch(setNotificationStatusUpdateCertidiedOtherCauses(value))
                                setOtherMotivationsNotify(value)
                                if(!value && notificationStatusState.notificationStatusUpdateRequest.certifiedNote)
                                    dispatch(setNotificationStatusUpdateCertifiedNote(''))
                            }}
                        />
                        <div className='ml-[25px]'>
                            <Input
                                disabled={!otherMotivationsNotify}
                                placeholder='Specifica altre cause...'
                                value={notificationStatusState.notificationStatusUpdateRequest.certifiedNote}
                                onChangeText={(text) => dispatch(setNotificationStatusUpdateCertifiedNote(text))}
                            />
                        </div>
                    </div>

                    <div className='text-left mb-5' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='notify-text-bold'>
                            Certificato associato alla Notifica:
                        </div>
                        <span className='notify-text-content pb-[2px]'>
                            n. del xx
                        </span>
                    </div>

                    <div>
                        <div className='text-left notify-subtitle'>
                            Certificato non emesso
                        </div>
                        <ProtocolSearch
                            type="departure"
                            defaultValue={notificationStatusState.notificationStatusUpdateRequest.notEmittedCertifiedId}
                            onSelect={(value) => dispatch(setNotificationStatusUpdateNotEmittedCertifiedId(value))}
                        />
                    </div>
                </div>

                <div className='mb-5'>
                    <div>
                        <div className='text-left notify-text-bold'>
                            Visita Ispettiva associata alla Notifica
                        </div>
                        <SelectCustom
                            placeholder=''
                            options={[]}
                        />
                    </div>
                </div>

                <div className='mb-5 pb-5' style={{ borderBottom: '1px solid #74A4A9' }}>
                    <div>
                        <div className='text-left notify-text-bold'>
                            Richiesta Integrazione Documenti (R.I.D.)
                        </div>
                        <SelectCustom
                            placeholder='Seleziona R.I.D...'
                            value={notificationStatusState.notificationStatusUpdateRequest.documentIntegrationRequestId}
                            options={RIDOptions}
                            onChange={(value) => dispatch(setNotificationStatusUpdateDocumentIntegrationRequestId(value))}
                        />
                    </div>
                </div>

                <div className='pb-5'>
                    <div className='text-left'>
                        <div className='notify-subtitle mb-3'>
                            Cause della variazione
                        </div>
                    </div>

                    <VariationTable 
                        defaultValue={notificationStatusState.notificationStatusUpdateRequest.variationCauses}
                        onChange={(value) => dispatch(setNotificationStatusUpdateVariationCauses(value))}
                    />
                </div>

                <div>
                    <div className='text-left notify-text-bold'>
                        Note
                    </div>
                    <TextArea 
                        value={notificationStatusState.notificationStatusUpdateRequest.note}
                        onChangeText={(text) => dispatch(setNotificationStatusUpdateNote(text))}
                        />
                </div>

            </div>
        </div>
    )
}